export default {"src":"/_next/static/media/deco_checkout_applepaycard.4991e820.svg","height":34,"width":54,"blurWidth":0,"blurHeight":0};